import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationHelperService } from '../services/translations/translation-helper.service';

@Pipe({
  name: 'translate',
  pure: false,
  standalone: false,
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private subscription?: Subscription;
  private currentKey?: string;
  private currentValue?: string;

  constructor(
    private readonly translationHelper: TranslationHelperService,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  transform(key: string | null | undefined): string {
    if (!key) {
      return '';
    }

    if (key !== this.currentKey) {
      this.subscribeToKey(key);
    }

    return this.currentValue ?? key;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private subscribeToKey(key: string): void {
    this.subscription?.unsubscribe();
    this.currentKey = key;
    this.currentValue = key;
    this.subscription = this.translationHelper.observe(key).subscribe((value) => {
      this.currentValue = value;
      this.cdr.markForCheck();
    });
  }
}
